import { PRICE_REPRESENTATION_MULTIPLIER, type Pricing } from '../Pricing.ts';
import type { ProductGenericPriceDTO } from '@/services/generated/ECAPIProductsDTOs.ts';

// Generated Type is Wrong
export interface ProductDetailPricesDTO {
  productId?: string;
  prices?: ProductGenericPriceDTO[];
}

export function fromEcapiDto(priceDto: ProductDetailPricesDTO): Pricing {
  const priceDetails = priceDto.prices?.at(0)?.priceDetails;
  return {
    price: (priceDetails?.price ?? 0) * PRICE_REPRESENTATION_MULTIPLIER,
    ...(priceDetails?.pricePerUnit
      ? {
          pricePerCapsule:
            (priceDetails?.pricePerUnit ?? 0) * PRICE_REPRESENTATION_MULTIPLIER
        }
      : {}),
    ...(priceDetails?.pricePerSleeve
      ? {
          pricePerSleeve:
            (priceDetails?.pricePerSleeve ?? 0) *
            PRICE_REPRESENTATION_MULTIPLIER
        }
      : {}),
    ...(priceDetails?.pricePerWeight
      ? {
          pricePerWeight:
            (priceDetails?.pricePerWeight ?? 0) *
            PRICE_REPRESENTATION_MULTIPLIER
        }
      : {})
  };
}
